<template>
  <div class="matching-type-help-column">
    <div class="matching-type-help-column__title">
      {{ title }}
    </div>
    <p class="matching-type-help-column__description">
      <slot />
    </p>
    <div class="matching-type-help-column__search">
      <p class="matching-type-help-column__search-title">
        {{ $t('ADVERTISEMENT.BID.MATCH_TYPE_EXAMPLE_TITLE') }}
      </p>
      <div class="matching-type-help-column__search-box">
        <span class="matching-type-help-column__search-icon el-icon-search" />
        <span>
          {{ keywords }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MatchingTypeHelpColumn',
  props: {
    title: {
      type: String,
      required: true,
    },
    keywords: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.matching-type-help-column {
  display: flex;
  flex-direction: column;

  &__title {
    text-align: center;
    font-weight: bold;
    margin-bottom: $global-margin;
  }

  &__description {
    text-align: center;
  }

  &__search {
    margin-top: auto;
  }

  &__search-title {
    font-weight: bold;
    text-align: center;
  }

  &__search-box {
    width: 100%;
    border: 1px solid black;
    border-radius: 5px;
    padding: $global-padding / 2;

    display: flex;
    align-items: center;
  }

  &__search-icon {
    margin-right: calc($global-margin / 2);
    @include rtl() {
      margin-left: calc($global-margin / 2);
      margin-right: 0;
    }
  }
}
</style>
